import { Renderer2, RendererFactory2 } from "@angular/core";
import { LocalStorageService } from "ngx-webstorage";
import { BehaviorSubject } from "rxjs";
import { OverlayContainer } from "@angular/cdk/overlay";
import { AccountService } from "../auth/account.service";
import { first } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "../auth/account.service";
import * as i2 from "ngx-webstorage";
import * as i3 from "@angular/cdk/overlay";
import * as i4 from "@angular/common";
/**
 * La clase que encapsula los temas esperamos que terminen todos en -theme
 */
var TERMINACION_CLASES_TEMAS = "-theme";
/**
 * Clase para aplicar los estilos de Elemento Seleccionado
 */
var CLASE_DESTACAR_SELECCION = "destacar-seleccion";
/** Clase para aplicar el tamanyo mediano a los elementos */
var CLASE_ANCHURA_MEDIANA = "anchura-mediana";
/** Clase para aplicar el tamanyo grande a los elementos */
var CLASE_ANCHURA_GRANDE = "anchura-grande";
/**
 * Enumerado de los distintos temas visuales disponibles
 */
export var TemasVisualesEnum;
(function (TemasVisualesEnum) {
    TemasVisualesEnum[TemasVisualesEnum["Predeterminado"] = 0] = "Predeterminado";
    TemasVisualesEnum[TemasVisualesEnum["AltoContraste"] = 1] = "AltoContraste";
})(TemasVisualesEnum || (TemasVisualesEnum = {}));
/**
 * Identifica los posibles temas visuales
 */
export var TamanyosElementosEnum;
(function (TamanyosElementosEnum) {
    TamanyosElementosEnum[TamanyosElementosEnum["Predeterminado"] = 0] = "Predeterminado";
    TamanyosElementosEnum[TamanyosElementosEnum["AnchuraMediana"] = 1] = "AnchuraMediana";
    TamanyosElementosEnum[TamanyosElementosEnum["AnchuraGrande"] = 2] = "AnchuraGrande";
})(TamanyosElementosEnum || (TamanyosElementosEnum = {}));
/**
 * Clave para almacenado y obtenido de la configuracion del localStorage
 */
var CONFIGURACION_PERSONALIZACION = "configuracion_personalizacion";
/**
 * Data service que almacena la informacion global del interacciones
 * de la aplicacion con el usuario y las almacena para que se persistan
 * entre sesiones
 *
 * Algunos datos que almacena y gestiona este data service es la gestion
 * de los datos de accesbilidad, pagina actual, etc.
 */
var PersonalizacionDataService = /** @class */ (function () {
    function PersonalizacionDataService(accountService, localStorageService, rendererFactory, overlayContainer, document) {
        var _this = this;
        this.accountService = accountService;
        this.localStorageService = localStorageService;
        this.rendererFactory = rendererFactory;
        this.overlayContainer = overlayContainer;
        this.document = document;
        this.accesibilidadPorDefecto = {
            temaVisual: TemasVisualesEnum.Predeterminado,
            tamanyoElementos: TamanyosElementosEnum.Predeterminado,
            ayudaEnPantalla: false,
            destacarSeleccion: false,
        };
        this._configuracionPersonalizacion = new BehaviorSubject(this.accesibilidadPorDefecto);
        this.renderer = this.rendererFactory.createRenderer(null, null);
        var accountObservable = this.accountService.getAuthenticationState();
        if (accountObservable != null) {
            accountObservable.pipe(first()).subscribe(function (account) {
                var configuracion = _this.localStorageService.retrieve(CONFIGURACION_PERSONALIZACION + "&id=" + account.email);
                if (!configuracion) {
                    configuracion = _this.accesibilidadPorDefecto;
                }
                _this.inicializarConfiguracion(configuracion);
                _this._configuracionPersonalizacion.next(Object.assign({}, configuracion));
            });
        }
    }
    Object.defineProperty(PersonalizacionDataService.prototype, "configuracion", {
        get: function () {
            return this._configuracionPersonalizacion.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    PersonalizacionDataService.prototype.guardarConfiguracion = function (configuracion) {
        var _this = this;
        var accountObservable = this.accountService.getAuthenticationState();
        if (accountObservable != null) {
            accountObservable.pipe(first()).subscribe(function (account) {
                _this.localStorageService.store(CONFIGURACION_PERSONALIZACION + "&id=" + account.email, configuracion);
                _this.inicializarConfiguracion(configuracion);
                _this._configuracionPersonalizacion.next(Object.assign({}, configuracion));
            });
        }
    };
    PersonalizacionDataService.prototype.inicializarConfiguracion = function (configuracion) {
        this.establecerTemaVisual(configuracion.temaVisual);
        this.establecerDestacarSeleccion(configuracion.destacarSeleccion);
        this.establecerTamanyoElementos(configuracion.tamanyoElementos);
    };
    PersonalizacionDataService.prototype.obtenerTemasVisuales = function () {
        return [
            {
                id: TemasVisualesEnum.Predeterminado,
                i18n: "header.personalizar.temaColores.predeterminado",
                claseTemaCSS: "predeterminado-theme",
            },
            {
                id: TemasVisualesEnum.AltoContraste,
                i18n: "header.personalizar.temaColores.altoContraste",
                claseTemaCSS: "alto-contraste-theme",
            },
        ];
    };
    PersonalizacionDataService.prototype.obtenerTamanyosElementos = function () {
        return [
            {
                id: TamanyosElementosEnum.Predeterminado,
                i18n: "header.personalizar.tamanyoElementos.predeterminado",
                porcentajeAumento: 0,
            },
            {
                id: TamanyosElementosEnum.AnchuraMediana,
                i18n: "header.personalizar.tamanyoElementos.anchuraMediana",
                porcentajeAumento: 25,
            },
            {
                id: TamanyosElementosEnum.AnchuraGrande,
                i18n: "header.personalizar.tamanyoElementos.anchuraGrande",
                porcentajeAumento: 50,
            },
        ];
    };
    PersonalizacionDataService.prototype.establecerTemaVisual = function (temaVisual) {
        var clasesOverlayContainer = this.overlayContainer.getContainerElement()
            .classList;
        var clasesTemasAEliminar = Array.from(clasesOverlayContainer).filter(function (clase) { return clase.includes(TERMINACION_CLASES_TEMAS); });
        if (clasesTemasAEliminar) {
            clasesOverlayContainer.remove.apply(clasesOverlayContainer, clasesTemasAEliminar);
        }
        var claseTemaVisual = this.obtenerTemasVisuales()[temaVisual]
            .claseTemaCSS;
        clasesOverlayContainer.add(claseTemaVisual);
        if (this.claseTemaActual) {
            this.renderer.removeClass(this.document.body, this.claseTemaActual);
        }
        this.renderer.addClass(this.document.body, claseTemaVisual);
        this.claseTemaActual = claseTemaVisual;
    };
    PersonalizacionDataService.prototype.establecerTamanyoElementos = function (tamanyoElementos) {
        this.renderer.removeClass(this.document.body, this.claseTamanyoActual);
        if (tamanyoElementos === TamanyosElementosEnum.AnchuraMediana) {
            this.renderer.addClass(this.document.body, CLASE_ANCHURA_MEDIANA);
            this.claseTamanyoActual = CLASE_ANCHURA_MEDIANA;
        }
        else if (tamanyoElementos === TamanyosElementosEnum.AnchuraGrande) {
            this.renderer.addClass(this.document.body, CLASE_ANCHURA_GRANDE);
            this.claseTamanyoActual = CLASE_ANCHURA_GRANDE;
        }
    };
    PersonalizacionDataService.prototype.establecerDestacarSeleccion = function (debeDestacarseSeleccion) {
        if (debeDestacarseSeleccion) {
            this.renderer.addClass(this.document.body, CLASE_DESTACAR_SELECCION);
        }
        else {
            this.renderer.removeClass(this.document.body, CLASE_DESTACAR_SELECCION);
        }
    };
    PersonalizacionDataService.ngInjectableDef = i0.defineInjectable({ factory: function PersonalizacionDataService_Factory() { return new PersonalizacionDataService(i0.inject(i1.AccountService), i0.inject(i2.LocalStorageService), i0.inject(i0.RendererFactory2), i0.inject(i3.OverlayContainer), i0.inject(i4.DOCUMENT)); }, token: PersonalizacionDataService, providedIn: "root" });
    return PersonalizacionDataService;
}());
export { PersonalizacionDataService };
